import StationMessageService from '@/service/StationMessageService'

const newMessage = {
    etText: null,
    enText: null,
    fiText: null,
    ltText: null,
    probes: [],
    messageType: null,
}

const initialState = {
    tableData: [],
    newMessage: { ...newMessage },
    allProbes: [],
    loading: false,
    tableOptions: null,
    count: 0,
    errorMessages: [],
}

export default {
    namespaced: true,
    state: { ...initialState },
    actions: {
        async getStationErrorMessages({ commit }) {
            try {
                commit('setLoading', true)
                const resp = await StationMessageService.getStationErrorMessages()
                commit('setLoading', false)
                if (!resp?.data) return
                commit('setErrorMessages', resp.data.messages)
            } catch (e) {
                console.error(e)
                commit('setLoading', false)
            }
        },
        async getAllStationMessages({ state, commit }) {
            const params = {
                page: state.tableOptions && state.tableOptions.page ? state.tableOptions.page : 1,
                itemsPerPage:
                    state.tableOptions && state.tableOptions.itemsPerPage ? state.tableOptions.itemsPerPage : 20,
                type: 'messages',
            }
            try {
                commit('setLoading', true)
                const resp = await StationMessageService.getAllStationMessages(params)
                commit('setLoading', false)
                if (!resp?.data) return
                commit('setCount', resp.data.count)
                commit('setTableData', resp.data.messages)
            } catch (e) {
                console.error(e)
                commit('setLoading', false)
            }
        },
        async getStationMessageProbes({ commit }) {
            try {
                commit('setLoading', true)
                const resp = await StationMessageService.getStationMessageProbes()
                commit('setLoading', false)
                if (!resp?.data) return
                commit('setAllProbes', resp.data.all_probes)
            } catch (e) {
                console.error(e)
                commit('setLoading', false)
            }
        },
        async updateStationMessage({ commit, dispatch }, payload) {
            try {
                commit('setLoading', true)
                const resp = await StationMessageService.updateStationMessage(payload)
                commit('setLoading', false)
                if (resp.status === 204) {
                    await dispatch(
                        'app/showSnackbar',
                        {
                            bool: true,
                            message: 'New station message updated!',
                            type: 'success',
                        },
                        { root: true }
                    )
                    commit('resetNewMessage')
                } else {
                    await dispatch(
                        'app/showSnackbar',
                        {
                            bool: true,
                            message: 'Fail!',
                            type: 'error',
                        },
                        { root: true }
                    )
                }
            } catch (e) {
                console.error(e)
                commit('setLoading', false)
            }
        },
        async createNewStationMessage({ state, commit, dispatch }) {
            try {
                commit('setLoading', true)
                const resp = await StationMessageService.createStationMessage(state.newMessage)
                commit('setLoading', false)
                if (resp.status === 201) {
                    await dispatch(
                        'app/showSnackbar',
                        {
                            bool: true,
                            message: 'New station message added!',
                            type: 'success',
                        },
                        { root: true }
                    )
                    commit('resetNewMessage')
                } else {
                    await dispatch(
                        'app/showSnackbar',
                        {
                            bool: true,
                            message: 'Fail!',
                            type: 'error',
                        },
                        { root: true }
                    )
                }
            } catch (e) {
                console.error(e)
                commit('setLoading', false)
            }
        },
        async deleteStationMessage({ commit, dispatch }, payload) {
            try {
                commit('setLoading', true)
                const resp = await StationMessageService.deleteStationMessage(payload)
                commit('setLoading', false)
                if (resp.status === 204) {
                    await dispatch(
                        'app/showSnackbar',
                        {
                            bool: true,
                            message: 'New station message deleted!',
                            type: 'success',
                        },
                        { root: true }
                    )
                    commit('resetNewMessage')
                } else {
                    await dispatch(
                        'app/showSnackbar',
                        {
                            bool: true,
                            message: 'Fail!',
                            type: 'error',
                        },
                        { root: true }
                    )
                }
            } catch (e) {
                console.error(e)
                commit('setLoading', false)
            }
        },
    },
    mutations: {
        resetNewMessage(state) {
            state.newMessage = newMessage
        },
        setLoading(state, payload) {
            state.loading = payload
        },
        setAllProbes(state, payload) {
            state.allProbes = payload
        },
        setCount(state, payload) {
            state.count = payload
        },
        setTableData(state, payload) {
            state.tableData = payload
        },
        setErrorMessages(state, payload) {
            state.errorMessages = payload
        },
    },
    getters: {},
}
